//script for view item list 
window.dataLayer = window.dataLayer || [];

document.addEventListener("DOMContentLoaded", function () {
  // prevent duplicate firing
  if (window.__viewItemListFired) return;

  const productCards = document.querySelectorAll('[data-product-card]'); 
  if (!productCards.length) return;

  const items = [];

  productCards.forEach((card, index) => {
    const productId = card.dataset.productId || "";
    const variantId = card.dataset.variantId || "";
    const itemId = productId && variantId
      ? `shopify_us_${productId}_${variantId}`
      : "";
    items.push({
      item_id: itemId,
      item_name: card.dataset.title || "",
      price: Number(card.dataset.price || 0),
      index: index + 1
    });
  });

  if (!items.length) return;


//   window.dataLayer.push({
//     event: "view_item_list",
//     ecommerce: {
//       item_list_name: document.title.includes("Search") ? "Search Results" : "Collection",
//       currency: Shopify.currency.active,
//       items
//     }
//   });

    const payload = {
    currency: Shopify?.currency?.active || "USD",
    item_list_name: document.title.includes("Search")
      ? "Search Results"
      : "Collection",
    items: items
  };


  gtag("event", "view_item_list", payload);


  window.__viewItemListFired = true;
});

/* // view_type pdp page event
document.addEventListener("DOMContentLoaded", function () {

  // product page check
  if (!window.ShopifyAnalytics?.meta?.product) return;

  // ensure gtag exists
  if (typeof gtag !== "function") {
    console.warn("gtag not loaded");
    return;
  }

  const product = ShopifyAnalytics.meta.product;

  const variant =
    product.variants?.find(v => v.id == product.selectedVariantId) ||
    product.variants?.[0];

  if (!variant) return;
  
  const itemId = `shopify_us_${product.id}_${variant.id}`;

  const payload = {
    view_type: "detail",
    currency: Shopify.currency.active || "USD",
    items: [{
      item_id: itemId,
      item_name: variant.name,
      price: Number(variant.price) / 100
    }]
  };
   console.log("product",product);
  
  gtag("event", "view_item", payload);
}); */

//view option for cards less than 5 
document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll("[data-product-card]");

  // only run if cards < 5
  if (!cards.length || cards.length >= 7) return;

  if (typeof gtag !== "function") {
    console.warn("gtag not available");
    return;
  }

  const currency = Shopify?.currency?.active || "USD";

 // prevents repeat firing
  const fired = new WeakSet();

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const card = entry.target;

        // prevent duplicate
        if (fired.has(card)) return;

        fired.add(card);
        obs.unobserve(card);

        const productId = card.dataset.productId || "";
        const variantId = card.dataset.variantId || "";

        const itemId = productId && variantId
          ? `shopify_us_${productId}_${variantId}`
          : "";

        const payload = {
          view_type: "option",
          currency,
          items: [{
            item_id: itemId,
            item_name: card.dataset.title || "",
            price: Number(card.dataset.price || 0)
          }]
        };

          console.log('payload',payload);

        gtag("event", "view_item", payload);
      });
    },
    {
      threshold: 0.5 // fires when 50% visible
    }
  );
  cards.forEach(card => observer.observe(card));
});





